module.exports = __webpack_public_path__ + "2425a18cb3edf84408236efe6ad40412.png";